const Scrolling = {
  NEAR_BOTTOM: 60,
  NEAR_TOP: 500,
};

export default Scrolling;
